import React from 'react';
import Button from '../../common/Button';

const EstablishmentUsersTable = ({
    establishmentusers,
    editEstablishmentUser,
    selectEstablishmentUsers,
    isAdminUser,
    selectedUserIdsList
}) => {
    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th>
                        </th>
                        <th className="non-mobile">First Name</th>
                        <th className="non-mobile">Last Name</th>
                        <th className="non-mobile">Email</th>
                        <th className="non-mobile">Role</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {establishmentusers && establishmentusers.map((establishmentuser) => {
                        return (
                            <tr>
                                <td><input 
                                    type="checkbox"
                                    name={establishmentuser.first_name + ' '+establishmentuser.last_name}
                                    id={establishmentuser.user_id}
                                    checked={selectedUserIdsList.find((userId) => userId == establishmentuser.user_id)}
                                    onChange={(e) => selectEstablishmentUsers(e)} /></td>
                                <td className="non-mobile">{establishmentuser.first_name}</td>
                                <td className="non-mobile">{establishmentuser.last_name}</td>
                                <td className="non-mobile">{establishmentuser.email}</td>
                                <td className="non-mobile">{establishmentuser.user_role}</td>
                                <td className="non-mobile">{isAdminUser && <Button name={establishmentuser.user_role} value="Edit User Role" id={establishmentuser.email}
                                    onClick={() => editEstablishmentUser(establishmentuser)}/>}</td>
                            </tr>);
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default EstablishmentUsersTable;


/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentUsersTable/EstablishmentUsersTable.js
 **/